export const agentAPIMap = {
  "Housing": "https://api.housinglegal.botpoc.platform.org.za",
  // "Housing - Evaluation & Report": "https://api.housingevalreport.botpoc.platform.org.za",
  "Precscripts": "https://prescript.bot.platform.org.za/ask",  
};